import React from "react";
import { Layout } from "antd";
import "./ChantContainer.css";
import ChantSpinner from "../ChantSpinner/ChantSpinner";

const { Content } = Layout;

const ChantContainer = ({ children, loading, loadingTitle = "Loading..." }) => {
  return (
    <Layout className="chant-container">
      <Content className="chant-content">
        {loading ? (
          <ChantSpinner isScreenLoader={true} text={loadingTitle} />
        ) : (
          children
        )}
      </Content>
    </Layout>
  );
};

export default ChantContainer;
